'use strict';

const $ = require('jquery');
require('magnific-popup');

const dates = require('util/date');

const find = require('lodash/find');
const map = require('lodash/map');
const isEmpty = require('lodash/isEmpty');
const forEach = require('lodash/forEach');

/**
 * Ported over from Signature Theatre.
 *
 * @param $scope
 * @param $location
 * @param $anchorScroll
 * @param $timeout
 * @param calendarService
 * @returns {controller}
 */
function controller($scope, $location, $anchorScroll, $timeout, calendarService) {
    let vm = this;

    vm.loading = true;
    vm.selectedMonth = null;
    vm.accessibilityFilter = false;
    vm.showDropdown = false;

    let calendar = null,
        months = [],
        totalMonths = 0;

    vm.init = function () {
        calendarService.getEvents().then(() => {
            vm.loading = true;

            calendar = calendarService.getWeeks(false, dates.moment());

            vm.weekDays = calendarService.weekDays;
            vm.calendar = map(calendar, (month, monthIndex) => {
                return month.map(function (dayObj) {
                    var monthID = dayObj.day.format('YYYY-MM');

                    dayObj.id = 'day-' + dayObj.day.format('YYYY-MM-DD');
                    dayObj.class = 'month-' + dayObj.day.format('YYYY-MM');
                    dayObj.title = dayObj.day.format('DD ddd');
                    dayObj.monthID = dayObj.class;

                    if (monthIndex > 0) {
                        dayObj.prevMonthID = calendar[monthIndex - 1][15].day.format('\\mont\\h-YYYY-MM');
                    }

                    if (monthIndex < calendar.length - 1) {
                        dayObj.nextMonthID = calendar[monthIndex + 1][15].day.format('\\mont\\h-YYYY-MM');
                    }

                    if (!(monthID in months)) {
                        months[monthID] = {
                            index: totalMonths++,
                            day: dayObj.day,
                            id: dayObj.id,
                            total: 0
                        };
                    }

                    months[monthID].total++;

                    return dayObj;
                });
            });

            // Want the first month selected automatically unless a url hash has been passed
            if ($location.hash()) {
                vm.selectedMonth = find(vm.calendar, month => {
                    return month[15].monthID === $location.hash();
                });
                if (vm.selectedMonth) {
                    $timeout(() => {
                        vm.navigateTo();
                    }, 10);
                }
            }
            if (!vm.selectedMonth) {
                vm.selectedMonth = vm.calendar[0];
            }

            $(window).on('scroll', vm.checkSlectedMonth);

            vm.loading = false;
        });
    };

    vm.checkSlectedMonth = () => {
        const calendarHeaderRect = document.querySelector('.calendar__header').getBoundingClientRect();
        const offset = calendarHeaderRect.top + calendarHeaderRect.height;
        const visibleMonth = find(vm.calendar, month => {
            const id = month[15].monthID;
            const elem = document.getElementById(id);
            return isScrolledIntoView(elem, offset);
        });
        if (!vm.selectedMonth || (visibleMonth && vm.selectedMonth[15].monthID !== visibleMonth[15].monthID)) {
            $timeout(() => {
                vm.selectedMonth = visibleMonth;
            });
        }
    };

    /**
     * Taken from (https://stackoverflow.com/questions/487073/check-if-element-is-visible-after-scrolling?page=1&tab=votes#tab-top)
     */
    const isScrolledIntoView = (el, offset) => {
        const rect = el.getBoundingClientRect();
        // const elemTop = rect.top;
        const elemBottom = rect.bottom;

        // Only completely visible elements return true:
        const isVisible = (elemBottom >= offset);
        // Partially visible elements return true:
        //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    }

    // /**
    //  * Taken from (https://stackoverflow.com/questions/487073/check-if-element-is-visible-after-scrolling?page=1&tab=votes#tab-top)
    //  */
    // const isElementInView = (element) => {
    //     const pageTop = $(window).scrollTop();
    //     const pageBottom = pageTop + $(window).height();
    //     const elementTop = $(element).offset().top;
    //     const elementBottom = elementTop + $(element).height();
    //
    //     return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    // };

    vm.openEventDetails = function (event) {
        $.magnificPopup.open({
            showCloseBtn: false,
            items: {
                src: '#event-detail-' + event.perf_no
            },
            type: 'inline',
            callbacks: {
                open: function() {
                    $('.calendar-event__close').on('click',function(event){
                        event.preventDefault();
                        $.magnificPopup.close();
                    });
                }
            }
        });
    }

    vm.eventIsAvailable = function (event) {
        return (event.availability_status === 'Seats Available') || (event.availability_status === 'Low Availability');
    }

    vm.getEventStatus = function (event) {
        return event.availability_status.replace(/\s+/g, '-').toLowerCase();
    }

    vm.navigateTo = function () {
        const calendarHeaderRect = document.querySelector('.calendar__header').getBoundingClientRect();
        const offset = calendarHeaderRect.top + calendarHeaderRect.height;
        $anchorScroll.yOffset = offset - 3;

        $location.hash(vm.selectedMonth[15].monthID);
        $anchorScroll();
    }

    /**
     * This is crazy due to the data structure. Calendar object is made up of
     * days and within each day there are multiple productions. Each production
     * will have group of performances associated with it. Hence, we have to
     * loop all the way into individual performances to check if it has any
     * access type set and add a property named - 'hide'. We then use it to
     * show or hide performances when access event filter is checked.
     *
     * Similarly, we loop all the way into individual performances and remove
     * the hide property to disable the filter.
     *
     * This is a bit unfortunate but feel free to improve it if you can.
     */
    vm.filterAccessEvents = function () {
        if (vm.accessibilityFilter) {
            forEach(vm.calendar, month => {
                forEach(month, dayObj => {
                    if (!isEmpty(dayObj.events)) {
                        forEach(dayObj.events, perfGroups => {
                            forEach(perfGroups, event => {
                                if (event.access_types.length === 0) {
                                    event.hide = true;
                                }
                            });
                        });
                    }
                });
            });
        } else {
            forEach(vm.calendar, month => {
                forEach(month, dayObj => {
                    if (!isEmpty(dayObj.events)) {
                        forEach(dayObj.events, perfGroups => {
                            forEach(perfGroups, event => {
                                delete event.hide;
                            });
                        });
                    }
                });
            });
        }
    }

    vm.toggleDropdown = () => {
        vm.showDropdown = !vm.showDropdown;
    }

    vm.getDayClasses = (day, month) => {
        return {
            'today': day.isToday,
            'past': day.isInPast,
            'event': day.hasEvents,
            'is-first-of-month': day.isStartOfMonth,
            'not-this-month': month[15].class !== day.class,
            'past-week': day.isWeekInPast,
        };
    }

    vm.dayEventClasses = item => {
        return {
            'sold-out': item.availability_status === 'Sold Out',
            'is-past': item.isPast,
        };
    }

    return vm;
}

module.exports = [
    '$scope',
    '$location',
    '$anchorScroll',
    '$timeout',
    'calendarService',
    controller
];
